<template>
	<div className="w-full h-screen font-sans relative outer-container" v-if="loaded">
		<br />

		<main>
			<router-view />
		</main>
	</div>
	<div class="loader-view" v-else>
		<div class="loader"></div>
		<div class="msg-empty">Уншиж байна {{ msg }}</div>
	</div>
</template>

<script>

export default {
	data() {
		return {
			msg: '',
			loaded: false,
		};
	},
	mounted() {
		this.$auth.setToken(
			'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIxUGVuLXhod2FsWWxneWd1ZlpJQW9wTjBJU2t5bkdjR09BWmxOVllMY21RIn0.eyJqdGkiOiIzNzcyNGFhMS1kM2M2LTRhOTItYTI4NS00NTQ4MzU1NTYzYzIiLCJleHAiOjE2ODMxOTM0OTYsIm5iZiI6MCwiaWF0IjoxNjgzMTkyODk2LCJpc3MiOiJodHRwczovL3Nzby1zdGFnaW5nLmludmVzY29yZS5tbi9hdXRoL3JlYWxtcy9pbnZlc2NvcmUiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiYWUwYjI0NzMtODI2ZS00MDEzLWIyNWMtYTk1MzZmNDY3YTYzIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiYXV0aC1iYWNrIiwiYXV0aF90aW1lIjowLCJzZXNzaW9uX3N0YXRlIjoiZDc5NmMxZTAtOTNiNi00ZjNhLWJlZmMtNTg2NGY3ZDhjNDNjIiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyIqIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJjdXN0b21lciJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuaWNrbmFtZSI6IjcyMTc2NDkzMDkzMjQyIiwibmFtZSI6ItCh0L7QvdC40L0t0J7QtCDQrdGA0LTRjdC90Y0t0J7Rh9C40YAiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiI5MzM5NTMwMCIsImdpdmVuX25hbWUiOiLQodC-0L3QuNC9LdCe0LQiLCJmYW1pbHlfbmFtZSI6ItCt0YDQtNGN0L3RjS3QntGH0LjRgCIsImVtYWlsIjoic29uaW5vZEBnbWFpbC5jb20iLCJ1c2VybmFtZSI6IjkzMzk1MzAwIn0.d_Xvh0rCtQW_ef_0Pvw_vkutTYbDtvS3b-wOPRoz0V2HT4fojZoGB72zbzJAihJ2-Ze_oZ64PE4cMSnsSrEOlFmllDqa_7RA7sgboUI2N8ssaPB6ZIQB-mNgT6yQXWhZsFGw2DLnVelwo-FxV0JXKFsDhIWagsHpya_uHxiF-xnZ6IqhsEA2XKWMAG8_LxT45Sb_wwJSlevzU-1Djh_k-klm5nFOcqrmwWnR3wsY8JcIA6960ecM_DcnQSV6SsW0V0urkfggeTl2m9ibC9UXgB64EY7VAdI29AkXVKv9Ry7mOb8OeRhEVBktZz4Ooqeh8i5ZnpXkTZ7UaE_1-6Onjw'
		);
		this.loaded = true;
		// this.start();
	},
	methods: {
		start() {
			window.Pocket.getToken({}, (params) => {
				if (params.error) {
					console.log(params.errorMessage);
				} else {
					this.$auth.setToken(params.data.accessToken);
					this.$auth.setRefreshToken(params.data.refreshToken);
					this.loaded = true;
				}
			});
		},
	},
};
</script>

<style>
</style>
